import React from 'react'
import SuperUserPageSF from './SuperUserPageSF'
import SearchUI from '../widgets/input/SearchUI'
import BadgeUI from '../widgets/output/BadgeUI'
import SwitchUI from '../widgets/action/SwitchUI'
import LRTableBodyUI from '../widgets/layout/LRTableBodyUI'
import LRTableRowLinkUI from '../widgets/layout/LRTableRowLinkUI'
import './SuperUserAccountName.css'

const SuperUserAccountNameUI = ({ context, className, topnav, backLink, headerText, subHeaderText, dimension, centered, children, page, accountUserList,
  searchFilter, onSearchFilterChange, checked, onShowUnread
}) =>
  <SuperUserPageSF
    context={context}
    className={className}
    topnav={topnav}
    backLink={backLink}
    headerText={headerText}
    subHeaderText={subHeaderText}
    dimension={dimension}
    centered={centered}
    children={children}
    sideBar={
      <SideBarUI
        page={page} accountUserList={accountUserList} searchFilter={searchFilter} onSearchFilterChange={onSearchFilterChange}
        checked={checked} onShowUnread={onShowUnread}
      />
    }
  />

const SideBarUI = ({ page, accountUserList, searchFilter, onSearchFilterChange, checked, onShowUnread }) =>
  <div className="sidebar">
    <h2 style={{ fontSize: '25px' }}>Chats</h2>
    <div className="search_container">
      <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
    </div>
    <div className='g_muted g_small'>
      Search by account name
    </div>
    <div className='g_flex_h g_flex_right g_m_bottom_100'>
      <span className='g_muted g_m_right_50'>
        Unread
      </span>
      <SwitchUI
        checked={checked}
        onChange={onShowUnread}
      />
    </div>
    <div className='account_list'>
      <LRTableBodyUI>
        {
          accountUserList && accountUserList.map((account) =>
            <SideBarItemUI key={account.accountId} label={account.accountName} to={`/su/accounts/${account.accountId}/chats`}
              active={page === account.accountId} message={account.latestDraftMessage !== null ? account.latestDraftMessage : account.latestMessage}
              unreadMessages={account.noOfUnreadMessages} />
          )
        }
      </LRTableBodyUI>
    </div>
    <div class="divider"></div>
  </div>

const SideBarItemUI = ({ label, message, to, active, unreadMessages }) =>
  <div>
    {
      message &&
      <LRTableRowLinkUI
        left={
          <div className='g_flex_v'>
            <span className="account_name">{label}</span>
            <span className={message.status === 'draft' ? 'account_message g_success' : message.csr ? "account_message g_muted" : "account_message g_error"}>
              {message.status === 'draft' ? `draft: ${message.message}` : message.message}
            </span>
          </div>
        }
        right={
          <div className='g_flex_v'>
            <span className='g_flex_h g_flex_right g_m_bottom_100'>
              {
                unreadMessages !== 0 &&
                <BadgeUI label={unreadMessages} />
              }
            </span>
            <span className={message.csr ? "account_time g_muted" : "account_time g_error"}>
              {message.messageDate - Date.now() >= 3 ? message.messageDateTimeF.split(" ")[0] : message.messageDateTimeF.split(" ")[1]}
              {/* {message.messageDateTimeF.split(" ")[1]} Extracts only the time */}
            </span>
          </div>
        }
        to={to}
      />
    }
  </div>

export default SuperUserAccountNameUI
